module.exports = "<div class=\"e3-viewer-poi-info-fullscreen-wrapper\">\n    <img src=\"\" alt=\"\">\n    <div class=\"close-fullscr-img\"></div>\n</div>"